import * as React from 'react';

import { Field } from 'redux-form';

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';

import type { JobFieldProps } from './job-field';

import { JobField } from './job-field';

import { CkEditorFieldComponent } from '../../widgets/redux-form-fields/ckeditor-redux-form-component';

const styles = () =>
  createStyles({
    formField: {
      width: '100%',
    },
  });

interface Props extends JobFieldProps, WithStyles<typeof styles> {}

class JobFieldDescriptionComponent extends React.PureComponent<Props> {
  render() {
    const { classes, ...childrenProps } = this.props;

    const jobTemplatesLink = (
      <a
        href="https://drive.google.com/file/d/1YEQiKHqinFb8mHK1t0tPsH6b_9eN0YLO/view"
        target="new"
        className="typo-link"
      >
        Use one of our job templates
      </a>
    );
    return (
      <div className={classes.formField}>
        <JobField
          {...childrenProps}
          title="Job Description"
          caption={
            <div>
              This should be a full description of the job and will be available on the initial
              &apos;apply&apos; page, throughout the application workflow, and on any job boards we
              integrate with. Need help? {jobTemplatesLink}
            </div>
          }
          editView={<Field name="description" component={CkEditorFieldComponent} />}
        />
      </div>
    );
  }
}

export const JobFieldDescription = withStyles(styles)(JobFieldDescriptionComponent);
